export enum Middleware {
  REQUIRES_AUTH = 'requiresAuth',
  TOGGLES_NAV_DRAWER = 'togglesNavDrawer',
  FORCE_TOGGLES_NAV_DRAWER = 'forceTogglesNavDrawer',
  ADD_CURRENT_DATE_QUERY_PARAM = 'addCurrentDateQueryParam',
}
